import { render, staticRenderFns } from "./TicketsInfoDiscount.vue?vue&type=template&id=435f442e&scoped=true&lang=pug&"
import script from "./TicketsInfoDiscount.vue?vue&type=script&lang=js&"
export * from "./TicketsInfoDiscount.vue?vue&type=script&lang=js&"
import style0 from "./TicketsInfoDiscount.vue?vue&type=style&index=0&id=435f442e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435f442e",
  null
  
)

export default component.exports